export default __webpack_public_path__ + "static/media/neptik-logo.1c41518f.svg";